import { DDSDisplayText, DDSHeadlineText } from "@web-monorepo/dds";
import { Link } from "#/src/routes";
import css from "./NotFound.module.css";

const NotFound = () => (
  <main className={css.main}>
    <img className={css.bg} src="404-bg.png" alt="" />
    <section className={css.box}>
      <DDSDisplayText level="xl">Lost?</DDSDisplayText>
      <DDSHeadlineText as="h1">
        <Link to="/">Let's find our way home</Link>
      </DDSHeadlineText>
    </section>
  </main>
);

export default NotFound;
